import { render, staticRenderFns } from "./MultiLinks.vue?vue&type=template&id=495049ee&scoped=true"
import script from "./MultiLinks.vue?vue&type=script&lang=js"
export * from "./MultiLinks.vue?vue&type=script&lang=js"
import style0 from "./MultiLinks.vue?vue&type=style&index=0&id=495049ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495049ee",
  null
  
)

export default component.exports